export default __webpack_public_path__ + "static/2-data-types-08ef00b9d8a88fc39b858d34468711b3.png";